import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchImageSlider } from 'redux/image-sliders/actions';

import { Radio } from 'semantic-ui-react';

import ImageSliderDescription
  from 'components/dashboard/image-slider/ImageSliderDescription';
import ImageSliderLink
  from 'components/dashboard/image-slider/ImageSliderLink';
import CommonSliderImagesList
  from 'components/dashboard/image-slider/common-slider/CommonSliderImagesList';

import './CommonImageSliderDescriptionTabContent.css';


function CommonImageSliderDescriptionTabContent(props) {
  const { item, patchImageSlider } = props;
  const { t } = useTranslation();
  const [settingsMode, setSettingsMode] = useState(item.description_is_for_slider ? 'slider' : 'images');

  const onDescriptionModeChange = value => {
    const form = new FormData();
    form.append('description_is_for_slider', value);
    patchImageSlider(item.id, form);
  };

  return (
    <div className="common-image-slider-description-tab-content__component">
      <div
        className={`switch-item${settingsMode === 'slider' ? ' active' : ''}`}
        onClick={() => {
          setSettingsMode('slider');
          onDescriptionModeChange(true);
        }}
        role="button"
        tabIndex={-1}
      >
        <Radio
          label={t('For Slider')}
          checked={settingsMode === 'slider'}
        />
      </div>

      {settingsMode === 'slider' &&
        <div className="description-options">
          <ImageSliderDescription item={item} />
          <ImageSliderLink item={item} />
        </div>
      }

      <div
        className={`switch-item${settingsMode === 'images' ? ' active' : ''}`}
        onClick={() => {
          if (item.media_items && item.media_items.length > 0) {
            setSettingsMode('images');
            onDescriptionModeChange(false);
          }
        }}
        role="button"
        tabIndex={-1}
      >
        <Radio
          label={t('For Each Images')}
          checked={settingsMode === 'images'}
          disabled={item.media_items && item.media_items.length === 0}
        />
      </div>

      {settingsMode === 'images' &&
        <div className="images-options">
          <CommonSliderImagesList item={item} />
        </div>
      }
    </div>
  );
}

CommonImageSliderDescriptionTabContent.propTypes = {
  patchImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default connect(
  null,
  {
    patchImageSlider,
  },
)(CommonImageSliderDescriptionTabContent);
